export default '$$material';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/identifier.js
// module id = 136
// module chunks = 25